<template>
  <div id="app assignments" class="pt-2">
    <div v-if="loading" class="loading"></div>

    <div v-if="phrase != unlockPhrase">
      <div class="form-group column">
        <div class="col-4 col-sm-12">
          <label class="form-label" for="fandom-filter"
            >Enter unlock phrase:
          </label>
        </div>
        <div class="col-8 col-sm-12">
          <input
            class="form-input"
            type="text"
            id="phrase"
            placeholder="Enter passphrase..."
            v-model="phrase"
          />
        </div>
      </div>
    </div>

    <div v-if="phrase == unlockPhrase">
      <h3 class="show-sm">Assignments Export</h3>
      <p></p>

      <table class="table a-table">
        <thead>
          <th>Exchange</th>
          <th>Time Scraped</th>
          <th>Status</th>
          <th>CSV</th>
        </thead>
        <tbody>
          <tr
            v-for="row in assignmentsData"
            :key="`${row.exchange}-${row.scraped_at}`"
          >
            <td>{{ row.exchange }}</td>
            <td>
              {{ new Date(row.scraped_at).toLocaleString() }}
            </td>
            <td>
              {{ row.status }}
            </td>
            <td>
              <a
                v-if="row.status == 'COMPLETE'"
                :href="`https://autoao3.herokuapp.com/export/exchange/${
                  row.exchange
                }/assignments/${encodeURIComponent(row.scraped_at)}`"
                target="_blank"
                >CSV</a
              >
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import { orderBy } from "lodash-es";

export default {
  name: "assignments",
  data() {
    return {
      loading: false,
      assignmentsData: [],
      unlockPhrase: "modmodmod",
      phrase: "",
      scraperLoading: false,
      scraperRes: undefined
    };
  },
  beforeMount() {
    this.load();
  },
  computed: {
    ...mapGetters(["exchangeId"])
  },
  watch: {
    $route(to, from) {
      if (to.name != "assignments") return;

      if (
        to.name !== from.name ||
        this.exchangeId != this.$route.params.exchangeId
      ) {
        this.$store.commit("setExchangeId", this.$route.params.exchangeId);

        this.load();
      }
    }
  },
  methods: {
    // scrape() {
    //   this.scraperLoading = true;
    //   axios
    //     .get(`https://autoao3.herokuapp.com/scrape/${this.exchangeId}/gifts`)
    //     .then(res => {
    //       this.scraperRes = res;
    //       this.scraperLoading = false;
    //     })
    //     .catch(e => {
    //       if (e.response) {
    //         this.scraperRes = e.response;
    //         this.scraperLoading = false;
    //         return;
    //       }
    //       this.scraperRes = {
    //         error: true,
    //         e: e,
    //         msg: "Something went wrong! Report a bug."
    //       };
    //       this.scraperLoading = false;
    //     });
    // },
    async load() {
      this.$store.commit("setExchangeId", this.$route.params.exchangeId);

      if (!this.exchangeId || !this.exchangeId.length) return;

      this.loading = true;

      const url = `https://autoao3.herokuapp.com/db/exchanges/${encodeURIComponent(
        this.exchangeId
      )}/assignments`;

      const data = await axios
        .get(url)
        .then(res => res.data)
        .catch(() => []);

      this.assignmentsData = orderBy(data, [
        f => f.exchange,
        f => f.scraped_at
      ]);
      this.loading = false;
    }
  }
};
</script>

<style lang="scss">
// Tables
.a-table {
  border-collapse: collapse;
  border-spacing: 0;
  width: 100%;

  td,
  th {
    padding: 0.25rem;
    border-bottom: 1px solid #eee;
  }
  th {
  }
}
</style>
